import { render } from "./LicenseTypeList.vue?vue&type=template&id=cb346df2&scoped=true"
import script from "./LicenseTypeList.vue?vue&type=script&lang=js"
export * from "./LicenseTypeList.vue?vue&type=script&lang=js"

import "./LicenseTypeList.vue?vue&type=style&index=0&id=cb346df2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cb346df2"

export default script